export const PRIMARY = "#6C63FF";